import { render, staticRenderFns } from "./YouTube.vue?vue&type=template&id=d5bb107a&"
import script from "./YouTube.vue?vue&type=script&lang=js&"
export * from "./YouTube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5bb107a')) {
      api.createRecord('d5bb107a', component.options)
    } else {
      api.reload('d5bb107a', component.options)
    }
    module.hot.accept("./YouTube.vue?vue&type=template&id=d5bb107a&", function () {
      api.rerender('d5bb107a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/YouTube.vue"
export default component.exports